(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bimo-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bimo-announcements')) {
    customElements.define('bimo-announcements', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.messages = [...this.querySelectorAll('.bimo-news-message')];
        this.position = 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
        this.hovered = false;
        this.editing = false;
        this.interval = Math.max(4000, Number(this.dataset.interval) || 6000);
        this.pauseButton = this.querySelector('[data-pause]');
        if (this.messages.length < 2) return;
        this.querySelectorAll('button').forEach(button => { button.hidden = false; });
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.position - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.position + 1, true), options);
        this.pauseButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) this.paused = true;
          this.updatePause();
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.messages.findIndex(message => message.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editing = true;
          this.show(index, true);
        }, options);
        document.addEventListener('shopify:block:deselect', () => { this.editing = false; this.schedule(); }, options);
        this.updatePause();
        this.schedule();
      }
      show(index, manual = false) {
        this.position = (index + this.messages.length) % this.messages.length;
        this.querySelector('.bimo-news-messages').setAttribute('aria-live', manual ? 'polite' : 'off');
        this.messages.forEach((message, i) => {
          const active = i === this.position;
          message.classList.toggle('is-active', active);
          message.setAttribute('aria-hidden', String(!active));
          message.inert = !active;
        });
        this.schedule();
      }
      updatePause() {
        this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.paused || this.hovered || this.editing || document.hidden || this.contains(document.activeElement) || this.messages.length < 2) return;
        this.timer = setTimeout(() => this.show(this.position + 1), this.interval);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bimo-header"]) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.bimo-nav-group[open],.bimo-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.removeAttribute('open')})});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.bimo-nav-group[open],.bimo-mobile-menu[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary').focus()})});
document.addEventListener('toggle',event=>{if(event.target.matches('.bimo-nav-group[open]'))document.querySelectorAll('.bimo-nav-group[open]').forEach(menu=>{if(menu!==event.target)menu.removeAttribute('open')})},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modelpod-wiring"]) return;
  try {
    

function initModelpodWiring(root){
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const players=[...root.querySelectorAll('video')],status=root.querySelector('.mpw-status');
  for(const player of players)player.addEventListener('play',()=>{for(const other of players)if(other!==player)other.pause()});
  for(const button of root.querySelectorAll('[data-video]'))button.addEventListener('click',()=>{
    const player=document.getElementById(button.dataset.video);
    const seekAndPlay=async()=>{player.currentTime=Number(button.dataset.time);try{await player.play();status.textContent=root.dataset.playing}catch{status.textContent=root.dataset.playManual}};
    if(player.readyState>=1)seekAndPlay();else{player.addEventListener('loadedmetadata',seekAndPlay,{once:true});player.load()}
  });
}
document.querySelectorAll('.mp-wiring').forEach(initModelpodWiring);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.mp-wiring').forEach(initModelpodWiring));


  } catch(e) { console.error(e); }
})();
})();
